module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"station\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Stations\"\n  resource=\"Station\"\n  transformer=\"StationsTransforms\"\n  no-items-text=\"No Stations Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/stations/stations.html
// module id = 1378
// module chunks = 0